import React from 'react';
import { TopBar } from './TopBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { CanonicalInternalLinks } from './CanonicalInternalLinks';
import { BackToTop } from '../ui/BackToTop';
import { ScrollToHash } from '../ui/ScrollToHash';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col" data-id="element-569" data-mp="305la413znnar">
      <CanonicalInternalLinks data-id="element-570" data-mp="353wlwhdug7vm" />
      <ScrollToHash data-id="element-571" data-mp="352lhcfckqw3g" />
      <TopBar data-id="element-572" data-mp="355hfa3of9krw" />
      <Header data-id="element-573" data-mp="355r43nxqdlw0" />
      <main data-id="element-574" data-mp="3a27vqs452idu">{children}</main>
      <Footer data-id="element-575" data-mp="3a1exkfj8x17b" />
      <BackToTop data-id="element-576" data-mp="3a0wqenv1p2km" />
    </div>;
}